import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {GameComponent} from "./game.component";
import {RouterModule} from "@angular/router";
import {MaterialModule} from "@app/material/material.module";
import {FlexLayoutModule} from "@angular/flex-layout";
import {FuseSharedModule} from "@fuse/shared.module";
import {FuseConfirmDialogModule, FuseWidgetModule} from "@fuse/components";

import {CountdownTimerModule} from "ngx-countdown-timer";
import {MomentModule} from 'angular2-moment';
import {AuthGuard} from "@app/auth/auth.guard";
import {NgxPaginationModule} from 'ngx-pagination';
import {GameService} from "@app/main/content/game/game.service";
import { GameCardComponent } from './game-card/game-card.component';

const routes = [
  {
    path: '',
    component: GameComponent,
    canActivate: [AuthGuard],
    resolve: {
      data: GameService
    }
  }
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    FlexLayoutModule,
    MaterialModule,
    FuseSharedModule,
    FuseConfirmDialogModule,
    FuseWidgetModule,
    CountdownTimerModule.forRoot(),
    MomentModule,
    NgxPaginationModule
  ],
  declarations: [GameComponent, GameCardComponent],
  providers: [GameService]

})
export class GameModule {
}
